<div class="flex flex-column justify-content-center align-items-center w-full md:px-8 pb-3">
    <img src="/assets/images/features/Features6-400.webp" alt="Text Alert" class="max-h-18rem">
    <h2 class="text-center">Partner Perks is a Premium+ Feature</h2>
    <span class="text text-center">Members get $1000+ in immediate savings with perks and discounts from the top travel brands.</span>
    <div class="w-full grid mt-4">
    <div class="col-12 py-2">
        <p-button
          label="Learn More"
          styleClass="learn-btn w-full"
          severity="info"
          (click)="goToUpgrade()"
        ></p-button>
    </div>
        </div>
</div>
